// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { TEGueltigkeitEntity } from '../../../entities/mdqx/te-gueltigkeit.entity';

export enum TEGueltigkeitActionTypes {
    GetTEGueltigkeitenRequest = '[TEGueltigkeiten] Get Request',
    GetTEGueltigkeitenResponse = '[TEGueltigkeiten] Get Response',
}

export class GetTEGueltigkeitenRequest implements Action {
    readonly type = TEGueltigkeitActionTypes.GetTEGueltigkeitenRequest;
}

export class GetTEGueltigkeitenResponse implements Action {
    readonly type = TEGueltigkeitActionTypes.GetTEGueltigkeitenResponse;
    constructor(public Payload: TEGueltigkeitEntity[]) {}
}

export type TEGueltigkeitActions = GetTEGueltigkeitenRequest | GetTEGueltigkeitenResponse;
